import { render, staticRenderFns } from "./CampanhasInteligentes.vue?vue&type=template&id=1816543e&scoped=true"
import script from "./CampanhasInteligentes.vue?vue&type=script&lang=js"
export * from "./CampanhasInteligentes.vue?vue&type=script&lang=js"
import style0 from "./CampanhasInteligentes.vue?vue&type=style&index=0&id=1816543e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816543e",
  null
  
)

export default component.exports